import { render, staticRenderFns } from "./SignatureFlow.vue?vue&type=template&id=5641b216&scoped=true"
import script from "./SignatureFlow.vue?vue&type=script&lang=js"
export * from "./SignatureFlow.vue?vue&type=script&lang=js"
import style0 from "./SignatureFlow.vue?vue&type=style&index=0&id=5641b216&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5641b216",
  null
  
)

export default component.exports